import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  templateUrl: './auth-layout.component.html'
})
export class AuthLayoutComponent {}
